// extracted by mini-css-extract-plugin
export default {"companyType":"Table_companyType__KxKGs"};